import { makeStyles } from '@material-ui/core/styles'

// Shared look for dropdown menus (MUI Menu / Popover + MenuList + MenuItem).
// The account dropdown is the reference: a rounded, lightly bordered paper
// with an inset list of rounded items that get a soft fill on hover/focus.
// Leading and trailing icons are untouched; only the surface styling is shared.

export const MENU_INSET = 6
export const MENU_BORDER_RADIUS = 12
export const MENU_ITEM_BORDER_RADIUS = 8
export const MENU_BORDER_COLOR = 'rgba(0, 0, 0, 0.06)'
export const MENU_DIVIDER_COLOR = 'rgba(0, 0, 0, 0.06)'
export const MENU_ITEM_HOVER_BG = 'rgba(0, 35, 75, 0.06)'
export const MENU_ITEM_SELECTED_BG = 'rgba(0, 35, 75, 0.1)'

export const menuPaperStyles = {
  borderRadius: MENU_BORDER_RADIUS,
  border: `1px solid ${MENU_BORDER_COLOR}`,
  boxShadow:
    '0 12px 24px -4px rgba(16, 24, 40, 0.10), 0 4px 8px -2px rgba(16, 24, 40, 0.05)',
}

export const menuListStyles = {
  padding: MENU_INSET,
  outline: 'none',
  '& .MuiDivider-root': {
    margin: `${MENU_INSET}px -${MENU_INSET}px`,
    backgroundColor: MENU_DIVIDER_COLOR,
  },
}

// MUI's built-in MenuItem sets paddingTop/Bottom longhands and resets
// minHeight to auto from the `sm` breakpoint up, so both are restated here.
export const menuItemStyles = {
  minHeight: 40,
  paddingTop: 8,
  paddingBottom: 8,
  paddingLeft: 12,
  paddingRight: 12,
  borderRadius: MENU_ITEM_BORDER_RADIUS,
  fontSize: 14,
  lineHeight: '20px',
  '@media (min-width:600px)': {
    minHeight: 40,
  },
  '&:hover, &.Mui-focusVisible': {
    backgroundColor: MENU_ITEM_HOVER_BG,
  },
  '&.Mui-selected, &.Mui-selected:hover, &.Mui-selected.Mui-focusVisible': {
    backgroundColor: MENU_ITEM_SELECTED_BG,
  },
}

// For menus built from Popover/Popper + MenuList rather than MUI's Menu, which
// the theme's MuiMenu overrides can't reach.
export const useMenuSurfaceStyles = makeStyles(() => ({
  paper: menuPaperStyles,
  list: menuListStyles,
}))

export const menuThemeOverrides = {
  MuiMenu: {
    paper: menuPaperStyles,
    list: menuListStyles,
  },
  MuiMenuItem: {
    root: menuItemStyles,
  },
}
